<template>
  <v-btn icon @click='handleDialog(true)'>
    <iconify-icon class="iconify" data-icon="mdi-gear"/>
    <options-dialog :value="open" @input='handleDialog'/>
  </v-btn>
</template>


<script>
import { ref } from 'vue'
import OptionsDialog from './OptionsDialog.vue';
import { useEvent } from '../plugins/vue-gtag';

export default {
  components: { OptionsDialog },
  setup(){
    const open = ref(false);
    const gaOptions = useEvent('options_dialog')

    const handleDialog = (newVal)=>{
      open.value = newVal;

      gaOptions(newVal)
    }

    return {
      open,
      handleDialog,
    }
  }
};
</script>
